// extracted by mini-css-extract-plugin
export var copyableItem = "_42-0";
export var underlined = "_42-1";